// Dimensions in millimeters (mm)
// Conversion: 1 inch = 25.4 mm

// Standard grid formats for general use
export const GRID_FORMATS = [
  {
    id: '2x2',
    name: '2×2 Grid',
    description: '4 QR codes per page',
    columns: 2,
    rows: 2
  },
  {
    id: '3x3',
    name: '3×3 Grid',
    description: '9 QR codes per page',
    columns: 3,
    rows: 3
  },
  {
    id: '4x4',
    name: '4×4 Grid',
    description: '16 QR codes per page',
    columns: 4,
    rows: 4
  },
  {
    id: '5x5',
    name: '5×5 Grid',
    description: '25 QR codes per page',
    columns: 5,
    rows: 5
  }
];

// Avery label formats for printing on label sheets
export const AVERY_FORMATS = {
  '5160': {
    name: 'Avery 5160',
    description: 'Address Labels',
    pageSize: { width: 215.9, height: 279.4 }, // US Letter in mm
    labels: {
      columns: 3,
      rows: 10,
      width: 66.675,
      height: 25.4,
      marginTop: 12.7,
      marginLeft: 4.7625,
      columnGap: 3.175,
      rowGap: 0
    },
    labelsPerSheet: 30
  },
  '5163': {
    name: 'Avery 5163',
    description: 'Shipping Labels',
    pageSize: { width: 215.9, height: 279.4 },
    labels: {
      columns: 2,
      rows: 5,
      width: 101.6,
      height: 50.8,
      marginTop: 12.7,
      marginLeft: 4.7625,
      columnGap: 3.175,
      rowGap: 0
    },
    labelsPerSheet: 10
  },
  '5293': {
    name: 'Avery 5293',
    description: 'Square Labels',
    pageSize: { width: 215.9, height: 279.4 },
    labels: {
      columns: 3,
      rows: 4,
      width: 63.5,
      height: 63.5,
      marginTop: 12.7,
      marginLeft: 7.9375,
      columnGap: 4.7625,
      rowGap: 4.7625
    },
    labelsPerSheet: 12
  },
  'L7165': {
    name: 'Avery L7165',
    description: 'Shipping Labels (A4)',
    pageSize: { width: 210, height: 297 }, // A4 in mm
    labels: {
      columns: 2,
      rows: 4,
      width: 99.1,
      height: 67.7,
      marginTop: 13.1,
      marginLeft: 5.5,
      columnGap: 1.3,
      rowGap: 0
    },
    labelsPerSheet: 8
  }
}; 